/* eslint-disable no-console */
import { Dialog } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CloseIcon } from "../../../../assets/Icons";
import {
  addOfflineRecipient,
  initializeTransaction,
  offlineLoanLetter,
  offlineStudentPassport,
  offlineOffer,
  offlinePAN,
} from "../../../../services/offline";
import { offlineFlywire } from "../../../../store";
import Button from "../../../../components/ui/Button";

export const OfflineFlywireDocumentPage = () => {
  const [studentName, setStudentName] = useState<string>("");
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [studentID, setStudentID] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const offlineRemitter = JSON.parse(localStorage.getItem("offlineRemitter") || "{}");
  const [finalModal, showFinalModal] = useState<boolean>(false);
  const [transactionID, setTransactionID] = useState<string>("");
  const navigate = useNavigate();
  const [offlineFlywireData, setOfflineFlywireData] = useRecoilState(offlineFlywire);
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  const handleFinalNext = () => {
    setIsDisabled(false);
    const body = {
      firstName: studentName,
      middleName: "",
      nickName: "",
      lastName: "",
      relationship: "",
      sortCode: "",
      swiftCode: "",
      bsbCode: "",
      achCode: "",
      ibanCode: "",
      bankAccountNumber: offlineFlywireData?.bankAccountNumber
        ? offlineFlywireData?.bankAccountNumber
        : "N/A",
      countryofResidence: "",
      recipientAddress: "",
      unitNumber: "",
      city: "",
      phoneNumber: "",
      pinCode: "",
      transitCode: "",
      state: "",
      recipientLs: "",
      bankAccountCountry: "",
      currency: "",
      refrence: studentID,
      ifscCode: "",
      bankCode: "",
      email: "",
      bankName: offlineFlywireData?.bankName ? offlineFlywireData?.bankName : "N/A",
      offline: true,
    };
    addOfflineRecipient(offlineRemitter, currentUser, body)
      .then((response) => {
        setErrorMessage("");
        const body = {
          advance_pay: 0,
          base_currency: "INR",
          cgst: 0,
          conversion_rate: "",
          dest_currency: offlineFlywireData.currency ? offlineFlywireData.currency : "USD",
          hop_fees: "",
          igst_fees: "",
          reciepient_recieve: offlineFlywireData?.amount,
          service_tax: "",
          sgst: "",
          tcs: "",
          total_pay: offlineFlywireData.amount,
          total_tax: "",
          mgr_initial: "",
          transaction_purpose: "Overseas Education - Living Expenses",
          purposeCode: "S0305",
          transactionLeadIds: Object.values(offlineFlywireData?.transactionLeadIds),
          isA2FormConsent: "",
          user_send: "",
          isAdvancePay: false,
          isFullPay: true,
          hop_coins: 0,
          isEducation: true,
          id_recipient: response?.data?.id,
          conversion_amount: "",
          nostro_charges: "",
          nostro_charges_new: "",
          promo_code: "",
          promo_code_disount: "",
          vendor_margin: "",
          vendor_key: currentUser.vendor_key,
          referrerVendor: offlineFlywireData?.reference,
          isBene: "",
          isDualTransaction: "",
          bankName: offlineFlywireData.bankName,
          accNumber: offlineFlywireData.bankAccountNumber,
          modeOfTransaction: "Flywire",
        };
        initializeTransaction(offlineRemitter, currentUser, body)
          .then((response) => {
            setTransactionID(response?.data?.transactionNumber);
            showFinalModal(true);
          })
          .catch(() => {
            //something
          });
      })
      .catch((err) => {
        setErrorMessage(err?.response?.data?.error?.type);
      })
      .finally(() => setIsDisabled(false));
  };

  const uploadOfflineStudentPassport = async (e: any) => {
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlineStudentPassport(currentUser, data)
      .then((response) => {
        if (response.data.success === true) {
          setOfflineFlywireData({
            ...offlineFlywireData,
            transactionLeadIds: {
              ...offlineFlywireData.transactionLeadIds,
              offlineStudentPassports: response.data.leadDocId,
            },
          });
          setErrorMessage("");
        }
      })
      .catch((error) => {
        setErrorMessage(error.response.data.error.type);
      });
  };

  const uploadOfflineLoanLetter = async (e: any) => {
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlineLoanLetter(currentUser, data)
      .then((response) => {
        if (response.data.success === true) {
          setOfflineFlywireData({
            ...offlineFlywireData,
            transactionLeadIds: {
              ...offlineFlywireData.transactionLeadIds,
              offlineLoanLetter: response.data.leadDocId,
            },
          });
          setErrorMessage("");
        }
      })
      .catch((error) => {
        setErrorMessage(error.response.data.error.type);
      });
  };

  const offlineOfferLetter = async (e: any) => {
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlineOffer(currentUser, data)
      .then((response) => {
        if (response.data.success === true) {
          setOfflineFlywireData({
            ...offlineFlywireData,
            transactionLeadIds: {
              ...offlineFlywireData.transactionLeadIds,
              offlineUniOfferLetter: response.data.leadDocId,
            },
          });
          setErrorMessage("");
        }
      })
      .catch((error) => {
        setErrorMessage(error.response.data.error.type);
      });
  };

  const offlinePANUpload = async (e: any) => {
    const fileData = e.target.files[0];
    // eslint-disable-next-line prefer-const
    let data = new FormData();
    data.append("file", fileData);
    await offlinePAN(currentUser, data)
      .then((response) => {
        if (response.data.success === true) {
          setOfflineFlywireData({
            ...offlineFlywireData,
            transactionLeadIds: {
              ...offlineFlywireData.transactionLeadIds,
              offlinePAN: response.data.leadDocId,
            },
          });
          setErrorMessage("");
        }
      })
      .catch((error) => {
        setErrorMessage(error.response.data.error.type);
      });
  };

  return (
    <div>
      <div id="wrapper" className="flex flex-col items-center w-full">
        <div
          onClick={() => navigate("/home")}
          className="p-5 ml-[1420px] mt-2 hover:scale-150 transition-all cursor-pointer"
        >
          <CloseIcon />
        </div>
        <div className="w-[900px] border space-y-5 border-black rounded-xl mt-36 flex flex-col items-center">
          <span className="text-[35px] font-bold font-ssp">Student Document</span>
          <div id="payBox" className="flex flex-col border border-black p-7">
            <div className="flex items-center justify-between w-full mt-10">
              <div className="text-[19px] font-semibold">
                Student Name{" "}
                <span className="text-red-100 text-[18px] font-ssp font-semibold">*</span>
              </div>
              <div className="">
                <input
                  value={studentName}
                  onChange={(e) => setStudentName(e.target.value)}
                  placeholder="Enter Student Name"
                  className="w-full px-6 py-3 bg-blue-100 border rounded"
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
            </div>
            <div className="flex items-center justify-between w-full mt-10">
              <div className="text-[19px] font-semibold">
                Student ID{" "}
                <span className="text-red-100 text-[18px] font-ssp font-semibold">*</span>
              </div>
              <div className="">
                <input
                  value={studentID}
                  onChange={(e) => setStudentID(e.target.value)}
                  placeholder="Enter Reference"
                  className="w-full px-6 py-3 bg-blue-100 border rounded"
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
            </div>
            <div id="uploads" className="flex flex-col w-full mt-12 space-y-6">
              <div id="univofflet" className="flex items-center justify-between w-full space-x-16">
                <div className="flex items-center">
                  <span className="font-semibold font-ssp text-[19px]">
                    University Offer Letter{" "}
                    <span className="text-red-100 text-[18px] font-ssp font-semibold">*</span>
                  </span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => offlineOfferLetter(e)}
                />
              </div>
              <div id="pass" className="flex items-center justify-between w-full">
                <div className="flex items-center">
                  <span className="font-semibold font-ssp text-[19px]">
                    Passport{" "}
                    <span className="text-red-100 text-[18px] font-ssp font-semibold">*</span>
                  </span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => uploadOfflineStudentPassport(e)}
                />
              </div>
              <div id="pan" className="flex items-center justify-between w-full">
                <div className="flex items-center">
                  <span className="font-semibold font-ssp text-[19px]">PAN</span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => offlinePANUpload(e)}
                />
              </div>
              <div id="loan" className="flex items-center justify-between w-full">
                <div className="flex items-center">
                  <span className="font-semibold font-ssp text-[19px]">
                    Loan Disbursement Letter323
                  </span>
                </div>
                <input
                  accept="/*"
                  type="file"
                  className="w-[200px]"
                  onChange={(e: any) => uploadOfflineLoanLetter(e)}
                />
              </div>
            </div>
            <div className="flex flex-col items-center">
              <Button
                // disabled={!disableCondition}
                disabled={
                  !offlineFlywireData?.transactionLeadIds?.offlineUniOfferLetter ||
                  !offlineFlywireData?.transactionLeadIds?.offlineStudentPassports ||
                  !studentName ||
                  !studentID
                }
                isLoading={isDisabled}
                onClickHandler={handleFinalNext}
                className={clsx(
                  !offlineFlywireData?.transactionLeadIds?.offlineUniOfferLetter ||
                    !offlineFlywireData?.transactionLeadIds?.offlineStudentPassports ||
                    !studentID ||
                    !studentName
                    ? "px-10 py-4 mt-10 font-bold text-white bg-gray-500 transition-all rounded-lg shadow-xl"
                    : "px-10 py-4 mt-10 font-bold text-white transition-all rounded-lg shadow-xl cursor-pointer hover:bg-white hover:text-primary bg-primary hover:border-2 hover:border-primary",
                )}
              >
                Next
              </Button>
              <span className="mt-2 font-bold text-red-500">
                {errorMessage === "" ? "" : errorMessage}
              </span>
            </div>
          </div>
        </div>
      </div>
      <Dialog open={finalModal} onClose={() => showFinalModal(false)}>
        <div className="px-8 py-3 font-bold text-white bg-green-600">Offline Transaction</div>
        <div className="flex flex-col items-center px-10 py-4 space-y-2">
          <span className="font-bold text-[16px]">Transaction Completed</span>
          <span className="font-bold text-[16px]">Transaction ID: {transactionID} </span>
          <div
            onClick={() => navigate("/history")}
            className="px-6 py-2 font-bold text-white rounded cursor-pointer bg-primary"
          >
            Go to History
          </div>
        </div>
      </Dialog>
    </div>
  );
};
